import "core-js/modules/es.array.concat.js";
import { normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "custom-component title-element"
};
import commonTxt from './commonTxt.vue';
import { onMounted } from 'vue';
export default {
  __name: 'headline',
  props: {
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    element: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 组件 */
    var props = __props;
    var emit = __emit;
    onMounted(function () {
      emit('loaded', 'headline');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(commonTxt, {
        "initial-content": __props.elementContent.content,
        class: _normalizeClass('custom-paragraph-' + __props.element.elementType)
      }, null, 8, ["initial-content", "class"]), __props.elementContent.headline.style === 'simple' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["border", "border-".concat(__props.element.elementType, "-").concat(__props.elementContent.headline.style)])
      }, null, 2)) : _createCommentVNode("", true)]);
    };
  }
};